import { useEffect, useState } from "react";
import { getLogs } from "../APIs/api-routes.util";
import Header from "../Dashboard/Header";
import DataTable from "react-data-table-component";
import LogDetail from "./LogDetail";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Loader from "../common/spinner";
import { isMobile } from "react-device-detect";
const columns = [
  {
    name: "Time Stamp",
    // width: "5%",
    selector: (row: any) => row.timeStamp,
    sortable: true,
  },
  {
    name: "From",
    // width: "5%",
    selector: (row: any) => row.from,
    sortable: true,
  },
  {
    name: "Message",
    // width: "5%",
    selector: (row: any) => row.message,
    sortable: true,
  },
  
];

function filterTextObjects(data: any) {
  const textObjects: any[] = [];

  if (data && data.entry) {
    data?.entry.forEach((entry: any) => {
      if (entry?.changes) {
        entry?.changes.forEach((mess: any) => {
          if (mess?.value?.messages) {
            mess?.value?.messages.forEach((messag: any) => {
              if(messag?.text?.body) textObjects.push(messag?.text?.body);
            });
          }
        });
      }
    });
  }
  return textObjects;
}
function filterPhoneObjects(data: any) {
  const textObjects: any[] = [];

  if (data && data.entry) {
    data?.entry.forEach((entry: any) => {
      if (entry?.changes) {
        entry?.changes.forEach((mess: any) => {
          if(mess.value.messages) textObjects.push(mess.value.messages[0].from);
        });
      }
    });
  }
  return textObjects;
}

function Logs() {
  const [data, setData] = useState<any>([]);
  const [detail, setDetail] = useState({});
  const [showDetail, setShowDetail] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  // Usage

  const getAllLogs = () => {
    setShowLoader(true);

    getLogs().subscribe((res: any) => {
      setShowLoader(false);

      if ("response" in res && res.response) {
        const response = res.response;
        console.log(response);
        var logsData: any = [];
        response.forEach((element: any) => {
          var log = JSON.parse(element.post_body);
          if(log.entry[0].changes[0].value.messages) {
            var logData = {
              timeStamp: element.timestamp,
              from: log.entry[0].changes[0].value.messages[0].from,
              message: log.entry[0].changes[0].value.messages[0].text?.body,
            }
            logsData.push(logData);
          }
          
        });
        setData(logsData);
      }
    });
  };

  const handleRowClick = (row: any, event: any) => {
    setShowDetail(true);
    setDetail(row);
  };
  useEffect(() => {
    getAllLogs();
  }, []);

  return (
    <>
      <Loader show={showLoader} />

      <Header />
      {showDetail ? (
        <>
          <Button
            style={{ 
              margin: isMobile ? "5px" : "10px",
              fontSize: isMobile ? "14px" : "16px",
              padding: isMobile ? "8px 12px" : "10px 16px"
            }}
            onClick={() => setShowDetail(false)}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            &nbsp;{isMobile ? "Back" : "Back"}
          </Button>
          <LogDetail detail={detail} />
        </>
      ) : (
        <div className="main-container">
          <DataTable
            fixedHeader
            pagination
            // subHeader={true}
            responsive
            theme="solarized"
            highlightOnHover={true}
            pointerOnHover={true}
            onRowClicked={handleRowClick}
            fixedHeaderScrollHeight={isMobile ? "calc(100vh - 150px)" : "calc(100vh - 135px)"}
            paginationRowsPerPageOptions={isMobile ? [10, 15, 20] : [15, 20, 25, 30, 50]}
            columns={columns}
            data={data}
          />
        </div>
      )}
    </>
  );
}

export default Logs;
